













import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({})
export default class IconLegend extends Vue {
  @Prop({ required: true }) label;
  @Prop({ required: true }) value;
  @Prop({ required: true, type: String }) iconPath;
}
